import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Security|Dashboard|Watch Form|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateWatchForm';
export type SPCandidateWatchFormLocNames =
	| `${LocNameStart}LabelUntil`
	| `${LocNameStart}ErrorUntilRequired`
	| `${LocNameStart}LabelComments`
	| `${LocNameStart}ErrorCommentsRequired`
	| `${LocNameStart}ButtonRemoveWatch`
	| `${LocNameStart}ButtonUpdateWatch`
	| `${LocNameStart}ButtonWatch`
	| `${LocNameStart}ErrorNotification`
	| `${LocNameStart}RadioLabelActionRemoveWatch`
	| `${LocNameStart}RadioLabelActionUpdateWatch`;

export const spCandidateWatchFormLocs: LocDefs<SPCandidateWatchFormLocNames> = {
	SPCandidateWatchFormLabelUntil: {
		defaultValue: 'Until',
		description: 'Label for: Until.',
		displayPath: `${pathStart} Watch Until Date`,
		displayType: 'Label',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldLabel.Until',
		...sharedProperties,
	},
	SPCandidateWatchFormErrorUntilRequired: {
		defaultValue: 'A valid end date is required',
		description: 'Error for: The end date is required.',
		displayPath: `${pathStart}Watch Until Date Required`,
		displayType: 'Error',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldError.DateRequired',
		...sharedProperties,
	},
	SPCandidateWatchFormLabelComments: {
		defaultValue: 'Comments',
		description: 'Label for: Comments.',
		displayPath: `${pathStart}Comments`,
		displayType: 'Label',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldLabel.Comments',
		...sharedProperties,
	},
	SPCandidateWatchFormRadioLabelActionRemoveWatch: {
		defaultValue: 'Remove Watch',
		description: 'Label for Remove Watch radio button.',
		displayPath: `${pathStart}Radio Label Remove Watch`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateWatchFormRadioLabelActionUpdateWatch: {
		defaultValue: 'Update Watch',
		description: 'Label for Update Watch radio button.',
		displayPath: `${pathStart}Radio Label Update Watch`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateWatchFormErrorCommentsRequired: {
		defaultValue: 'Comments are required',
		description: 'Error for: Comments are required.',
		displayPath: `${pathStart}Comments Required`,
		displayType: 'Error',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldError.CommentsRequired',
		...sharedProperties,
	},
	SPCandidateWatchFormButtonRemoveWatch: {
		defaultValue: 'Remove Watch',
		description: 'Button for: Remove Watch.',
		displayPath: `${pathStart}Remove Watch`,
		displayType: 'Button',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.Button.StopWatch',
		...sharedProperties,
	},
	SPCandidateWatchFormButtonUpdateWatch: {
		defaultValue: 'Update Watch',
		description: 'Button for: Update Watch.',
		displayPath: `${pathStart}Update Watch`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCandidateWatchFormButtonWatch: {
		defaultValue: 'Watch',
		description: 'Button for: Watch.',
		displayPath: `${pathStart}Watch`,
		displayType: 'Button',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.Button.Watch',
		...sharedProperties,
	},
	SPCandidateWatchFormErrorNotification: {
		defaultValue: 'Please check the form for errors.',
		description: 'Error notification shown when the form is invalid.',
		displayPath: `${pathStart}Error Notification`,
		displayType: 'Error',
		...sharedProperties,
	},
};

export type SPCandidateWatchFormLocType = LocMap<SPCandidateWatchFormLocNames>;
